import { api } from 'api';
import { KAZAKHSTAN } from 'common/constants/region-codes';
import { State, Store } from 'store/types';
import { GlobalEvents } from '../global';
import { FETCH_LANDINGS } from './landings-info-constants';
import { Landing } from './landings-info-types';
import { getKzLandingsList } from './landings-info-utils';

/**
 * Загрузка информации о лендингах
 * @param store
 * @param regionId
 * @param landingName
 * @param isAvailable
 * @returns {Promise<Landing>}
 */

export const getLandingsInfo = (store: Store, regionId: string, landingName = '', isAvailable = '') => {
  const { apiKey, orchestratorHost, useCredentials, requestID } = store.get();

  if (regionId === KAZAKHSTAN) {
    return getKzLandingsList();
  }

  return api.get<Landing[]>(
    'get-landings-info',
    { regionId, landingName, isAvailable },
    {
      orchestratorHost,
      useCredentials,
      apiKey,
      requestID,
    }
  );
};

/**
 * Экшен загрузки инфы о лендингах
 * @param {Store} store
 * @param {string} landingName
 * @param {string} isAvailable
 * @returns {Promise<State>}
 */
export const loadLandingsInfoAction = (store: Store, landingName = '', isAvailable = '') =>
  new Promise<State>(resolve => {
    const { modelJson } = store.get();
    if (!modelJson.model) {
      resolve(store.get());
      return;
    }

    store.dispatch(GlobalEvents.setRequestParams, {
      orchestratorHost: process.env.ORCHESTRATOR_HOST,
      useCredentials: process.env.USE_CREDENTIALS === '1',
      apiKey: process.env.API_KEY,
    });
    store.dispatch(FETCH_LANDINGS.init, {
      landingName,
      isAvailable,
    });

    const unsub = store.on('@dispatch', state => {
      if (state.landings.loading) {
        return;
      }

      unsub();
      resolve(store.get());
    });
  });
